export default function DspController($state) {
  const vm = this;
  vm.state = $state;
  vm.options = [{ name: 'AppNexus', value: 'appnexus' }];

  vm.selected = vm.options[0];

  vm.changeDspState = () => {
    if (!vm.selected && vm.id) {
      return;
    }
    vm.state.go('dsp.appNexus', { id: vm.id });
  };
  return vm;
}

DspController.$inject = ['$state'];
